"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useAllowedRoles_1 = require("./useAllowedRoles");

var IfAllowedRoles = function IfAllowedRoles(_ref) {
  var children = _ref.children,
      _ref$roles = _ref.roles,
      roles = _ref$roles === void 0 ? [] : _ref$roles;
  var allowed = useAllowedRoles_1.useAllowedRoles(roles);

  if (typeof children === 'function') {
    return children(allowed);
  }

  return allowed ? children : null;
};

exports.IfAllowedRoles = IfAllowedRoles;